<template>
  <overlay-scrollbars :options="{ className: 'content-container custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <div class="center-container">
      <div class="center-content">
        <div class="placeholder-icon"><svg width="44px" height="44px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-object"></use></svg></div>
        <h2 class="bold">Avansert søk i objekter</h2>
        <p>Spesifiser søket ved å benytte filtermenyen til venstre.</p>
      </div>
    </div>
  </overlay-scrollbars>
</template>

<script>
export default {
  name: 'TheMainSearchAdvancedIntro'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TheMainSearchAdvancedIntro.vue